import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadFaqInvoices } from '@/redux/actions/faq';
import { SUPPORT_URL } from '@/config/urls/supportUrls';
import FaqDefault from '@/components/FrequentlyQuestions/FaqDefault';


const FaqInvoicesPage = ({ className }) => {
  const faq = useSelector(state => state.faq);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadFaqInvoices());
  }, [dispatch]);

  return (
    <FaqDefault
      questions={faq.invoices.questions}
      link={SUPPORT_URL}
      className={className}
      loading={faq.loading}
    />
  );
};

export default FaqInvoicesPage;
